import _ from 'lodash';
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import { getDateFormatted } from 'Core/data/Helpers';
import Icon from '@mui/material/Icon';
import { Button, Modal, ModalBody, ModalFooter } from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import { Alert } from '@mui/material';

//Notification
import RawMessageView from 'Modules/devices/.components/rawMessageView'

//Redux
import {
    rawMessageViewOpenModal,
    clearRedux
} from "Redux/actions";
import { maintenanceWarningsSearchDetailList, reset } from './redux/slice';

const DetailedList = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux states
    const { result, loading, data, openModal } = useSelector(state => state.maintenanceWarningsDetailedListRedux)
    const open = useSelector(state => state.rawMessageViewRedux.openModal)

    const roundDecimals = (num) => {
        if (num % 1 !== 0) {
            return parseFloat(num.toFixed(2));
        } else {
            return num;
        }
    }

    const closeModal = () => {
        dispatch(reset())
        dispatch(clearRedux("MAINTENANCE_WARNINGS_DETAILED_LIST"));
    }

    useEffect(() => {
        if (openModal && data) dispatch(maintenanceWarningsSearchDetailList(data))
    }, [openModal])

    let sdCard = data?.device?.sdCard ? JSON.parse(data?.device?.sdCard) : null

    return (
        <>
            <Modal
                open={openModal}
                title={`Details (${data?.warning})`}
                position="right"
                size="small"
                handleClose={closeModal}
                loading={loading}
            >
                <ModalBody>
                    <div style={{ padding: '0 10px', marginBottom: 30 }}>
                        {
                            !loading && sdCard && sdCard?.status && sdCard?.status?.toUpperCase() !== "NORMAL" &&
                            <Alert
                                style={{ marginTop: '-10px', display: 'flex', alignItems: 'center', height: 50, fontSize: 11 }}
                                severity="error"
                                icon={<Icon>cancel</Icon>}
                            >
                                <div style={{ display: 'grid' }}>
                                    <span>{messages['maintenance_warnings_tab_sd_card_status']}  <strong>{sdCard?.status}</strong></span>
                                    <span>{messages['maintenance_warnings_tab_last_status']}:  <strong>{sdCard?.updatedOn ? getDateFormatted(sdCard?.updatedOn, "date", "datetime", null, data?.timezone) : ''}</strong></span>
                                </div>
                            </Alert>
                        }
                        {result?.items?.length > 0 ? result?.items?.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    info
                                    customMessage={messages['maintenance_warnings_tab_details']}
                                    onClick={() => {
                                        dispatch(rawMessageViewOpenModal(true, item?.details ? JSON.parse(item?.details) : "", messages["maintenance_warnings_tab_details"]))
                                    }}
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['maintenance_warnings_tab_warning']}</label><span>{item.warning || ""}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['maintenance_warnings_tab_warning_time']}</label><span>{item.unitTime && getDateFormatted(item.unitTime, "date", "datetime", null, item.unit?.timezone)}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['maintenance_warnings_tab_value']}</label><span>{`${item.value ? roundDecimals(item.value) : ""}`}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['maintenance_warnings_tab_no_warnings']}</span></div>}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn btn-dark-blue"
                        onClick={() => closeModal()}
                    >
                        {messages['common_close']}
                    </Button>
                </ModalFooter>
            </Modal>
            {open && <RawMessageView />}
        </>
    )
}

export default DetailedList;